export default {
  tabTitle: 'Modelos de Referencia de Conocimiento Experto',
  createEkrm: 'Crear EKRM',
  search: 'Buscar',
  edit: 'Editar',
  close: 'Cerrar',
  clone: 'Clonar',
  deleteEkrm: 'Eliminar EKRM',
  printJsonToConsole: 'Imprimir JSON en consola',
  downloadPkl: 'Descargar PKL',
  headerName: 'Nombre',
  headerMarket: 'Mercado',
  headerCreatedOn: 'Creado el',
  headerCreatedBy: 'Creado por',
  headerActions: 'Acciones',
  building: 'Construyendo...',
  updating: '(Actualizando...)',
  draftDialogTitle: 'Crear EKRM',
  draftDialogText: 'Ya has comenzado a crear un EKRM. ¿Quieres continuar con ese, o descartarlo permanentemente y empezar desde cero?',
  continueBtn: 'Continuar',
  startFromScratchBtn: 'Empezar desde cero',
  deleteDialogTitle: 'Advertencia',
  deleteDialogText: 'Eliminando EKRM:',
  deleteDialogConfirm: 'Podrás recuperarlo durante 7 días solicitándolo a un administrador. ¿Estás seguro?',
  deleteDialogConfirmBuilding: 'Esta acción no se puede deshacer. ¿Estás seguro?',
  cancelBtn: 'Cancelar',
  deleteBtn: 'Eliminar',
  snackEkrmDeleted: 'EKRM eliminado',
  snackErrorDeletingEkrm: 'Error al eliminar EKRM',
  snackEkrmRenamed: 'EKRM renombrado',
  snackErrorRenamingEkrm: 'Error al renombrar EKRM',
  snackPklDownloadStarted: 'Descarga de PKL iniciada',
  snackErrorDownloadingPkl: 'Error al descargar archivo PKL',
  inputTooLong: '¡Entrada demasiado larga!'
}
